// extracted by mini-css-extract-plugin
export var arrows = "_5o-5";
export var decrementer = "_5o-9";
export var disabled = "_5o-3";
export var error = "_5o-1";
export var hiddenText = "_5o-a";
export var incrementer = "_5o-8";
export var input = "_5o-7";
export var inputWrapper = "_5o-0";
export var leadingIcon = "_5o-b";
export var readonly = "_5o-2";
export var regular = "_5o-6";
export var small = "_5o-4";